import React, {Fragment, useState, useContext} from "../../_snowpack/pkg/react.js";
import {LazyLoadImage} from "../../_snowpack/pkg/react-lazy-load-image-component.js";
import {Transition} from "../../_snowpack/pkg/@headlessui/react.js";
import {StarIcon as StarIconSolid} from "../../_snowpack/pkg/@heroicons/react/solid.js";
import {
  InformationCircleIcon,
  StarIcon as StarIconOutline
} from "../../_snowpack/pkg/@heroicons/react/outline.js";
import {NotificationContext} from "../App.js";
const LazyImage = ({
  src,
  scrollPosition
}) => /* @__PURE__ */ React.createElement("div", {
  className: "max-w-[40%] my-auto"
}, /* @__PURE__ */ React.createElement(LazyLoadImage, {
  src,
  placeholder: /* @__PURE__ */ React.createElement("img", {
    src: "img/amiibo-placeholder.png",
    className: "animate-pulse"
  }),
  className: "transition duration-200 ease-in-out hover:scale-110",
  scrollPosition
}));
const AmiiboCard = ({amiibo, onExpand, scrollPosition}) => {
  const [favorite, setFavorite] = useState(false);
  const [, setNotification] = useContext(NotificationContext);
  return /* @__PURE__ */ React.createElement(Transition, {
    as: Fragment,
    show: true,
    appear: true,
    enter: "transition-opacity duration-150 ease-in",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-150 ease-out",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-row gap-2 p-4 border rounded-md border-gray-300 dark:border-none bg-white dark:bg-gray-900 shadow-sm"
  }, /* @__PURE__ */ React.createElement(LazyImage, {
    src: amiibo.image,
    scrollPosition
  }), /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap-2 p-2"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "text-2xl font-header font-semibold dark:text-white"
  }, amiibo.character), /* @__PURE__ */ React.createElement("div", {
    className: "dark:text-gray-200"
  }, amiibo.gameSeries)), /* @__PURE__ */ React.createElement("div", {
    className: "ml-auto relative"
  }, /* @__PURE__ */ React.createElement(Transition, {
    show: !favorite,
    enter: "transition-opacity ease-in duration-200",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /* @__PURE__ */ React.createElement(StarIconOutline, {
    className: "absolute right-0 transition duration-100 ease-in-out w-6 h-6 text-yellow-400 dark:text-yellow-200 hover:text-yellow-600 dark:hover:text-yellow-400 hover:cursor-pointer hover:scale-125",
    onClick: () => {
      setFavorite(!favorite);
      setNotification({
        type: "success",
        message: `Added '${amiibo.name}' to favorites`
      });
    }
  })), /* @__PURE__ */ React.createElement(Transition, {
    show: favorite,
    enter: "transition-opacity ease-in duration-200",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /* @__PURE__ */ React.createElement(StarIconSolid, {
    className: "absolute right-0 transition duration-100 ease-in-out w-6 h-6 text-yellow-400 dark:text-yellow-200 hover:text-yellow-600 dark:hover:text-yellow-400 hover:cursor-pointer hover:scale-150",
    onClick: () => {
      setFavorite(!favorite);
      setNotification({
        type: "success",
        message: `Removed '${amiibo.name}' from favorites`
      });
    }
  })), /* @__PURE__ */ React.createElement("button", {
    className: "absolute bottom-0 right-0 inline-flex gap-2"
  }, /* @__PURE__ */ React.createElement(InformationCircleIcon, {
    className: "w-6 h-6 text-gray-600 dark:text-gray-200 transition duration-100 ease-in-out hover:text-gray-400 hover:scale-110",
    onClick: onExpand
  })))));
};
export default AmiiboCard;
